import {Question} from '@/types/content/Question';

export const Chapter4Questions: Question[] = [
  {
    headline: '第4章　車両の点検基準とカーチェックシートの記入方法',
    introduction: '',
    text: 'Aについて、以下の1.2.3より正しい数字を答えてくだい。',
    answers: [
      {
        label: '1. 252',
        correct: false,
      },
      {
        label: '2. 224',
        correct: false,
      },
      {
        label: '3. 196',
        correct: true,
      },
    ],
    description: 'この車の年ものは、6年ものですから年もの係数欄の0.7を使用し、小計280×0.7の計算で196となります。',
    imageFilePath: '/img/test/04-01q.png',
    exampleImageFilePath: '/img/test/04-01a.png',
  },
  {
    headline: '第4章　車両の点検基準とカーチェックシートの記入方法',
    introduction: '',
    text: 'Bについて、以下の1.2.3より正しい数字を答えてくだい。',
    answers: [
      {
        label: '1. 253',
        correct: true,
      },
      {
        label: '2. 217',
        correct: false,
      },
      {
        label: '3. 145',
        correct: false,
      },
    ],
    description: 'この車の車両クラスはⅠクラスですから、クラス係数欄の1.4を使用し、A+B+C欄 - 181×1.4の計算で-253.4となり、小数点以下第一位を四捨五入して、-253となります。',
    imageFilePath: '/img/test/04-02q.png',
    exampleImageFilePath: '/img/test/04-02a.png',
  },
  {
    headline: '第4章　車両の点検基準とカーチェックシートの記入方法',
    introduction: '',
    text: 'Cについて、以下の1.2.3より正しい数字を答えてくだい。',
    answers: [
      {
        label: '1. 15',
        correct: false,
      },
      {
        label: '2. 25',
        correct: false,
      },
      {
        label: '3. 40',
        correct: true,
      },
    ],
    description: '商品価値のプラス合計欄15と、装備品のプラス合計欄25を合計し、40となります。',
    imageFilePath: '/img/test/04-03q.png',
    exampleImageFilePath: '/img/test/04-03a.png',
  },
  {
    headline: '第4章　車両の点検基準とカーチェックシートの記入方法',
    introduction: '',
    text: 'Dについて、以下の1.2.3より正しい数字を答えてくだい。',
    answers: [
      {
        label: '1. 253',
        correct: false,
      },
      {
        label: '2. 326',
        correct: true,
      },
      {
        label: '3. 336',
        correct: false,
      },
    ],
    description: '車両本体計の-253と、商品価値のマイナス合計欄の-73と、装備品のマイナス合計欄の0を合計し、-326となります。',
    imageFilePath: '/img/test/04-04q.png',
    exampleImageFilePath: '/img/test/04-04a.png',
  },
  {
    headline: '第4章　車両の点検基準とカーチェックシートの記入方法',
    introduction: '',
    text: 'Eについて、以下の1.2.3より正しい数字を答えてくだい。',
    answers: [
      {
        label: '1. 879',
        correct: false,
      },
      {
        label: '2. 969',
        correct: true,
      },
      {
        label: '3. 1621',
        correct: false,
      },
    ],
    description: '基本価格の1250と、加点合計の40と、車検残加点の3と、自賠責残加点の2を足し、減点合計の326を引くことにより、合計969となります。',
    imageFilePath: '/img/test/04-05q.png',
    exampleImageFilePath: '/img/test/04-05a.png',
  },
];
